import {Component, Input, OnInit} from '@angular/core';
import {ListeContactService} from '../../../../../service/interne/contact/ListeContactService';
import {FormatIntranetShareService} from '../../../../../service/partage/prototype/FormatIntranetShareService';
import {ActivatedRoute} from '@angular/router';
import {DialogueShareService} from '../../../../../service/partage/utilitaire/DialogueShareService';
import {ContactService} from '../../../../../service/interne/contact/ContactService';
import {ListeContact} from '../../../../../model/liste/ListeContact';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-escal-liste-contact-fiche-intranet',
  templateUrl: './escal-liste-contact-fiche-intranet.component.html',
  styleUrls: ['./escal-liste-contact-fiche-intranet.component.scss'],
  providers: [ ListeContactService ]
})
export class EscalListeContactFicheIntranetComponent implements OnInit {
  @Input()
  private sub: any;
  listeContact: any;
  commentaires: string;
  afficher: string;
  nbCaracteres: number;
  listeId: number;
  importes: Array<any> = [];
  dejaImporte: boolean;
  suivisIDs: any;
  supportsAsso: any;
  listeContactId = 0;
  constructor(public formatIntranetShareService: FormatIntranetShareService, private listeContactService: ListeContactService,
              private route: ActivatedRoute, public dialogueShareService: DialogueShareService,
              private contactService: ContactService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.suivisIDs = [];
    this.supportsAsso = [];
    this.importes = [];
    this.nbCaracteres = 0;
    this.afficher = 'moins';
    this.sub = this.route.params.subscribe(async params => {
      this.listeId = params['id'];
      this.listeContactService.getListeContactEscalnetByAncienID(params['id']).then(cont => {
        const checkliste = cont['hydra:member'] as Array<ListeContact>;
        if (checkliste.length > 0) {
          this.dejaImporte = true;
        } else {
          this.dejaImporte = false;
        }
      });
      // récupérer toutes les informations de cette société
      await this.listeContactService.getListeContactIntranetByID(params['id'])
        .then(async (listeContact) => {
          this.listeContact = listeContact;
          if (this.listeContact != undefined) {
            // on ordonne les valeurs du tableau
            this.listeContact.contacts.sort(function compare(a, b) {
              if (a.nom < b.nom) {
                return -1;
              }
              if (a.nom > b.nom ) {
                return 1;
              }
              return 0;
            });
            this.listeContact.nom = this.listeContact.nom.replace('&amp;', '&');
            this.listeContact.nom = this.listeContact.nom.replace('&#039;', '’');
            this.listeContact.nom = this.listeContact.nom.replace('L&#039;', 'L’');
            // gérer affichage commentaire
            this.nbCaracteres = this.listeContact.commentaire.length;
            this.commentaires = this.listeContact.commentaire.substr(0, 150);
            // gérer affichage contact importé ou pas
            this.importes = [];
            let importe;
            let trouve;
            for (const contactListe of this.listeContact.contacts) {
              importe = {};
              trouve = null;
              importe.contactId = contactListe.id;
              await this.contactService.getDoublonEscalnetSiExiste(contactListe.id).then((retour) => {
                trouve = retour;
                // si pas trouvé
                if (trouve['hydra:member'].length >= 1) {
                  importe.isImporte = true;
                } else {
                  importe.isImporte = false;
                }
                this.importes.push(importe);
              });
            }
          }
        });
    });
  }


  changerAffichage() {
    if (this.afficher === 'plus') {
      this.commentaires = this.listeContact.commentaires.substr(0, 100);
      this.afficher = 'moins';
    } else {
      this.commentaires = this.listeContact.commentaires;
      this.afficher = 'plus';
    }
  }

  async importerListeContact() {
    this.spinner.show();
    // importer la liste
    await this.contactService.importerListeContact(this.listeId).then(async contacts => {
      await this.listeContactService.getListeContactEscalnetByAncienID(this.listeId).then(async (listeContact) => {
        this.listeContactId = listeContact['hydra:member'][0].id;
        if (contacts.length > 0) {
          for (const contactId of contacts) {
            this.suivisIDs = [];
            this.supportsAsso = [];
            await this.contactService.getAllInformationsContact(contactId).then(async contact => {
              if (contact != undefined) {
                // récupérer les assos
                this.suivisIDs = contact.suivis;
                this.supportsAsso = contact.cont_supp_asso;
                await this.importerContact(contactId);
              }
            });
          }
        }
        // redirection
        this.spinner.hide();
        await this.ngOnInit();
        await this.dialogueShareService.addDialogue('La liste a bien été importée');
      });
    });
  }

  async importerContact(contactId) {
    // importer le contact
    await this.contactService.importerContact(contactId).then(async r => {
      // associer le contact à la liste
      await this.listeContactService.associerContactListe(contactId, this.listeContactId).then();
      // Importer dans la base escalnet les suivis associés existants sur intranet
      if (this.suivisIDs.length > 0) {
        for (const suiviId of this.suivisIDs) {
          await this.contactService.importerSuiviIntranet(suiviId).then();
        }
      }
      // Importer dans la base escalnet les supports associés existants sur intranet
      if (this.supportsAsso.length > 0) {
        for (const support of this.supportsAsso) {
          await this.contactService.importerSupport(support.id, contactId).then();
        }
      }
    });
  }

}
